import { render, staticRenderFns } from "./drTipsDialog.vue?vue&type=template&id=797f55b0&scoped=true"
import script from "./drTipsDialog.vue?vue&type=script&lang=js"
export * from "./drTipsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f55b0",
  null
  
)

export default component.exports